<template>
	<div class="buy-button">
		<img class="wallet" src="../assets/wallet_icon.svg" width="30" height="30" alt="wallet">
		<span class="price hidden" :class="{ showPrice:isShow(2) }">45 000</span>
		<span class="price hidden" :class="{ showPrice:isShow(3) }">45 000</span>
		<span class="price hidden" :class="{ showPrice:isShow(4) }">45 000</span>
		<img class="rub" src="../assets/rub.svg" width="14" height="16" alt="wallet">
	</div>
</template>

<script>
  export default {
    name: 'buyButton',
    props: ['active'],
    data () {
      return {
      }
    },
    methods: {
      isShow: function (index) {
        return this.active === index
      }
    },
    components: {}
  }
</script>

<style scoped>
	.buy-button {
		margin: 33px 0 33px 0;
		padding: 18px;
		width: min-content;
		display: flex;
		align-items: center;
		font-family: opinionprocondensed, serif;
		font-size: 37px;
		border-top: 1px solid #fff;
		border-bottom: 1px solid transparent;
		background-color: #fff;
		box-shadow: 0 10px 35px 5px rgba(0, 0, 0, .1);
	}

	.buy-button:hover {
		cursor: pointer;
	}

	.buy-button:active {
		cursor: pointer;
		box-shadow: 0 10px 30px 4px #E6E6E6;
	}

	.price {
		font-family: opinionprocondensed, serif;
		white-space: nowrap;
		font-weight: 500;
		display: inline-block;
	}


	.hidden {
		height: 0;
		width: 0;
		visibility: hidden;
		opacity: 0;
	}

	.showPrice {
		height: auto;
		width: auto;
		margin: 0 0 0 8px;
		visibility: visible;
		opacity: 1;
		transition: opacity ease-out .6s;
	}

	.rub {
		margin-left: 5px;
		margin-top: 7px;
	}
	@media all and (max-width:1350px) {
		.buy-button {
			width: 63%;
			margin: 33px auto;
			padding: 9px 18px;
		}

		.hidden {
			height: 0;
			width: 0;
			visibility: hidden;
			opacity: 0;
			display: none;
		}

		.showPrice {
			height: auto;
			width: auto;
			display: inline;
			min-width: 90px;
			margin: 0 0 0 8px;
			visibility: visible;
			opacity: 1;
			transition: opacity ease-out .6s;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/buyButton.vue?218d35a7